<template>
  <div class="room" @click="parent_toggle_collapse(room.id)">
    <vb-card variant="horizontal"
      :card="card_room"
      @click_image="open_modal_room(room.id)"
      @click_title="parent_toggle_collapse(room.id)"
    >
      <div class="room__wrap">
        <room-info :room="room" />
        <div :class="'room__toggle ' + (!collapsed ? 'room__toggle--not-collapsed' : '')">
          <span class="room__toggle-price" v-if="price > 0">da € {{ price }}</span>
          <div class="room__toggle-btn">
            <span class="room__toggle-text">scegli</span>
            <vb-icon class="room__toggle-icon" :name="'angle_small_down'" :color="sass('info')" :size="25" />
          </div>
        </div>
      </div>
      <vb-icon
        class="room__dotted"
        :name="'dotted'"
        :color="sass('dark')"
        :size="25"
        @click="open_modal_room(room.id)"
        @click.stop
      />
    </vb-card>
    <vb-modal
      :vb_options="{
        id: 'modal_room_' + room.id,
        body_class: 'rooms__modal',
        title: room.name.it,
        size: 'lg',
        centered: true,
        hide_footer: true
      }"
    >
      <room-modal :room="room" />
    </vb-modal>
  </div>
</template>

<script>
import { format_beds, markup, round_up } from '@bookingv3/utilities'
import { smaller } from "mathjs"
import RoomInfo from '@bookingv3/components/blocks/detail/room/room-info'
import RoomModal from '@bookingv3/components/blocks/detail/room/room-modal'

export default {
  name: 'room',

  components: {
    'room-info': RoomInfo,
    'room-modal': RoomModal,
  },

  props: {
    room: Object
  },

  data() {
    return {
      collapsed: true // stato del collapse, attualmente utlizzato dall'icona arrow
    }
  },

  computed: {

    // Ritorna un oggetto per il componente vb-card => :card
    card_room(){
      return {
        image: (this.room.photos && this.room.photos.length)
          ? this.room.photos[0].url.standard
          : '/assets/images/common/statics/room_placeholder.png',

        title: (this.room.name && this.room.name.it)
          ? this.room.name.it
          : null,

        text: (this.room.description && this.room.description.it)
          ? this.room.description.it
          : null,

        subtitle: format_beds(this.room.bed_options),

        subtitle_icon: {
          name: 'doublebed',
          color: this.sass('dark'),
          size: 13
        }
      }
    },

    // Ritorna il prezzo più basso (senza tasse di soggiorno) tra tutti i products
    price(){
      return this.room.products.reduce((min_tot_amount, product) => {
        const tot_amount = round_up(markup(product.price.total_tax_free).live_price)
        return min_tot_amount === 0 || smaller(tot_amount, min_tot_amount) ? tot_amount : min_tot_amount
      }, 0)
    }

  },

  created() {
    window.eventBus.$off('recommended:open_room', this.open_from_recommended)
    window.eventBus.$on('recommended:open_room', this.open_from_recommended)
  },

  mounted() {
  },

  update() {
  },

  beforeDestroy() {
    window.eventBus.$off('recommended:open_room', this.open_from_recommended)
  },

  methods: {

    // Emette il toggle per aprire/chiudere il collapse della camera (data:collapsed)
    parent_toggle_collapse(payload) {
      this.$emit('toggle-collapse', payload)
      this.collapsed = !this.collapsed
    },

    open_from_recommended(room_id) {
      if (room_id !== this.room.id) return
      if (this.collapsed) this.parent_toggle_collapse(this.room.id)
      this.$nextTick(() => {
        this.$el.scrollIntoView({ behavior: 'smooth', block: 'start' })
      })
    },

    // Apre la modale delle info room
    open_modal_room(id) {
      this.$bvModal.show('modal_room_' + id)
    }
  },
}
</script>

<style lang="scss" scoped>

  .room {
    cursor: pointer;

    &__wrap {
      display: flex;
      align-items: center;
      justify-content: right;
      margin-top: 10px;

      @include media-breakpoint-up(md){
        margin-top: 1.25rem;
        justify-content: space-between;
      }
    }

    &__toggle {
      $this: &;
      display: flex;
      align-items: center;
      cursor: pointer;

      &-price {
        font-size: $font-size-md;
        color: $primary;
        background-color: $wild-sand;
        border-radius: $border-radius-lg;
        padding: 2px 3px;
        margin-right: $grid-gutter-width/3;
        display: none;

        @include media-breakpoint-up(lg){
          display: block;
        }
      }

      &-btn {
        display: flex;
        align-items: center;
      }

      &-text {
        color: $info;
        text-decoration: underline;
        font-weight: $vb-font-weight-semibold;
      }

      &-icon {
        position: relative;
        top: 3px;

        @at-root #{$this}--not-collapsed & {
          transform: rotate(-180deg);
        }
      }
    }

    &__dotted {
      position: absolute;
      top: 10px;
      right: 30px;
      cursor: pointer;
      display: none;

      @include media-breakpoint-up(lg){
        display: block;
      }
    }

    ::v-deep {

      .vb-card {

        &__title {
          text-decoration: underline;
          cursor: pointer;

          &:hover {
            color: $primary;
          }
        }

        &__subtitle {
          color: $secondary;
          font-weight: $vb-font-weight-semibold;

          &-icon {
            margin-top: 3px;
          }
        }

        &__text {
          height: 3rem;
          font-size: .875rem;
          overflow: hidden;
        }
      }
    }
  }

</style>